
export const authRoutes = [
  {
    path: '/login',
    meta: { title: 'Login' },
    name: 'Login',
    component: () => import('../views/auth/Login.vue')
  }
]
